<div *ngIf="!isContractor() && data.length > 0" style="margin-top: 15px;">
  <mat-toolbar class="form-toolbar"
    fxShow.gt-sm fxHide.lt-md>
    <span class="form-action-title">
      WAITLIST APPLICATIONS
    </span>
  </mat-toolbar>
  <div fxHide.gt-sm fxShow.lt-md>
    <div>
      <div class="form-action-title">Waitlist Applications</div>
    </div>
    <mat-divider></mat-divider>
  </div>
  <div
    style="margin-top: 18px;">
    <mat-card>
      <div>
        <div [innerHTML]="textHomeownerDwellingQualified"></div>
      </div>
      <div *ngFor="let dwelling of data" style="margin-top: 15px;">
       
          <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
            <div fxFlex='30%' style="display: flex;">
       
          <!-- <mat-icon mat-list-icon>home</mat-icon> -->
          <div ><mat-icon >home</mat-icon></div>
          <div>&nbsp;{{dwelling.name}} </div>
          </div>
          <div fxFlex='30%'>
         <div ><button
          mat-flat-button color="primary"
          href="javascript:void(0)"
          (click)="onWithdrawEvent(dwelling.id)">
          Withdraw application
        </button></div>
        <div fxFlex='40%'></div>
        
      </div>
   
      </div>
      
        </div>
        
    </mat-card>
  </div>
</div>
